import React, {useEffect, useRef} from 'react';
import * as d3 from 'd3';

var div_1_axis: any;
var div_2_axis: any;
var div_3_axis: any;
var div_4_axis: any;

var global_team_select: any;

function addRankSuffix(number: any) {
  if (number >= 11 && number <= 13) {
    return number + 'th'; // Special case for 11th, 12th, and 13th
  } else {
    const lastDigit = number % 10;
    switch (lastDigit) {
      case 1:
        return number + 'st';
      case 2:
        return number + 'nd';
      case 3:
        return number + 'rd';
      default:
        return number + 'th';
    }
  }
}

function draw(svgRef:any, circleColor: string, circleSize: number, dataPoints:any[], window_height: number, window_width: number) {
  const svg  = d3.select(svgRef.current)

  console.log("Inside d3Example}");

  console.log(dataPoints);
  svg.selectAll("*").remove();


  var margin = {top: 100, right: 100, bottom: 30, left: 150},
  width = window_width*.75 - margin.left - margin.right,
  height = window_height*.75 - margin.top - margin.bottom;

  svg.attr("height", height + margin.top + margin.bottom)
  svg.attr("width", width + margin.left + margin.right)

  const x_min = d3.min(dataPoints, d => d['season_end_year']);
  const x_max = d3.max(dataPoints, d => d['season_end_year']);

  const y_min = d3.min(dataPoints, d => d['pos_full']);
  const y_max = d3.max(dataPoints, d => d['pos_full']);


  var x = d3.scaleLinear()
  .domain([x_min,x_max])
  .range([0, width ]);
  
  // Add Y axis
  var y = d3.scaleLinear()
    .domain([y_max,y_min])
  .range([height, 0]);

const league_name_y = [11, 48-12, 74-12, 100-12];


div_1_axis = d3.scaleLinear()
  .domain([1,22])
.range([y(1), y(22)]);


div_2_axis = d3.scaleLinear()
.domain([1,22])
.range([y(24), y(48)]);

div_3_axis = d3.scaleLinear()
.domain([1,22])
.range([y(50), y(74)]);

div_4_axis = d3.scaleLinear()
.domain([1,22])
.range([y(76), y(100)]);

var div_axes = [div_1_axis, div_2_axis, div_3_axis, div_4_axis]

let chartCanvas = svg.append("g")
.attr("transform",
      "translate(" + margin.left + "," + margin.top + ")");

for (let i = 0; i < div_axes.length; i++) {
  chartCanvas.append("g")    
  .attr("transform", "translate(" + -10 + ", 0)")
          .attr('class', 'div' + i)
          .call(d3.axisLeft(div_axes[i]).tickValues([5, 10, 15, 20]));

  d3.selectAll(".div" + i + " path")
  .style("display", "none"); // Hide the axis line

  d3.selectAll(".div" + i + " path")
  .style("font-size", "8px"); // Adjust the font size as needed


}


  //Set Top X-Axis
  chartCanvas.append("g")
  .attr("transform", "translate(0," + -50 + ")")
        .attr('class', 'x axis')
        .call(d3.axisTop(x).tickFormat(d3.format('.0f')));


// Add CSS to style the axis
d3.selectAll(".div.place path")
  .style("display", "none"); // Hide the axis line

d3.selectAll(".div.place text")
  .style("font-size", "8px"); // Adjust the font size as needed







var rect_height = height/(y_max - y_min)*0.9
var rect_width = width/(x_max - x_min)*0.9

let text: any


  chartCanvas.append('g')
    .selectAll("dot")
    .data(dataPoints)
    .enter()
    .append("rect")
    .attr('class', 'data_points')
    .attr("team", function (d) { return d['team_consolidated']; }) // Set a custom attribute
    .attr("color", function (d) { return d['team_color']; }) // Set a custom attribute
    .attr("season", function (d) { return d['season_end_year']; }) // Set a custom attribute
    .attr("division", function (d) { return d['division']; }) // Set a custom attribute
    .attr("position", function (d) { return d['Pos']; }) // Set a custom attribute
    .attr("width", function (d) { 
                    if(d['division'] == '3n' || d['division'] == '3s'){
                      return rect_width/2
                    } else {
                      return rect_width
                    }})
    .attr("height", rect_height)
    .attr("rx", rect_width*0.1)
    .attr("ry", rect_width*0.1)
    .attr("x", function (d) { 
                if(d['division'] == '3n'){
                  return x(d['season_end_year'])
                } else if(d['division'] == '3s'){
                  return x(d['season_end_year'] + 0.5)
                }else {
                  return x(d['season_end_year'])
                }} )
      .attr("y", function (d) { return y(d['pos_full']); } )
      .style("fill", function(d){ 
        return ( d['team_color'] )})
      .style("opacity", 0.3)
      .on("mouseover" , mouseover)
      .on("mouseleave", mouseleave );


  function mouseover(this:any , d:any ) {
    const hoveredTeam = d3.select(this).attr("team"); // Use "this" to access the DOM element

    const season_hover = d3.select(this).attr("season"); // Use "this" to access the DOM element
    const position_hover = addRankSuffix(d3.select(this).attr("position")); // Use "this" to access the DOM element
    const color_hover = d3.select(this).attr("color"); // Use "this" to access the DOM element


    const division_hover = d3.select(this).attr("division"); // Use "this" to access the DOM element

    let division_full_string;
    if(division_hover == '3n'){
      division_full_string = "3rd Division North, "
    } else if(division_hover == '3s') {
      division_full_string = "3rd Division South, "
    } else {
      division_full_string = addRankSuffix(parseFloat(division_hover)) + " Division, "
    }


      text = chartCanvas
      .append('text')
      .attr('x', width*0.025)
      .attr('y', -margin.top/5)
      .style('font-weight', 'bold')
      .attr('class', 'custom-tooltip')
      .text(season_hover + ' - ')
      .append('tspan')
      .text(hoveredTeam)
      .style('fill', color_hover)
      .append('tspan')
      .style('fill', "#404040")
      .text(': ')
      .style('font-weight', 'normal')
      .append('tspan')
      .text(division_full_string)
      .append('tspan')
      .text(position_hover + ' Place');





    chartCanvas.selectAll("rect[team='" + hoveredTeam + "']")
    .style("opacity", 1)
    .style("stroke", "black") // Set the border color to black
    .style("stroke-width", "1px"); // Set the border width to 2 pixels (adjust as needed)
  }

  function mouseleave(this:any , d:any ) {
    const hoveredTeam = d3.select(this).attr("team"); // Use "this" to access the DOM element

    console.log("global_team_select")
    console.log(global_team_select)
    console.log(hoveredTeam)

    if(global_team_select.length == 0){
      chartCanvas.selectAll("rect[team='" + hoveredTeam + "']")
      .style("opacity", 0.3)
      .style("stroke", "none");
  d3.selectAll('.custom-tooltip').remove();
    }

    if(global_team_select[0].Team != hoveredTeam){
              chartCanvas.selectAll("rect[team='" + hoveredTeam + "']")
          .style("opacity", 0.3)
          .style("stroke", "none");
      d3.selectAll('.custom-tooltip').remove();
    }
 else{


      d3.selectAll('.custom-tooltip').remove();
    }

  }



const leauge_names = ["Premier League", "Championship", "League One", "League Two"];
//const league_name_y = [11, 48-12, 74-12, 100-12];


// Iterate through the array using a for loop
for (let i = 0; i < leauge_names.length; i++) {

  chartCanvas.append("text")
  .attr('x', 0)
  .attr('y', 0)      
  .text(leauge_names[i])
  .attr('class', leauge_names[i] + " text")
  .style("font-size", "12px") // Adjust the font size as needed
  .style("text-anchor", "middle") // Center the text horizontally
  .attr("transform", "translate(" + -margin.left*0.275 + "," +  y(league_name_y[i]) + ") rotate(-90)")
  .style('font-weight', 600)

  var y_start = 0
  var y_end = 0

  if(i == 0){
    y_start = league_name_y[i] - 11
    y_end =  league_name_y[i] + 11
  }
  else{
    y_start = league_name_y[i] - 12
    y_end =  league_name_y[i] + 12
  }

  chartCanvas.append("line")
  .attr('class', leauge_names[i] + " line")
  .attr("x1", -margin.left*0.225)
  .attr("x2", -margin.left*0.225)
  .attr("y1", y(y_start))
  .attr("y2", y(y_end))
  .style("stroke", "black"); // Color of the underline
}
    
    
}

function redraw(svgRef:any, leagues:number, dataPoints:any[], seasons:number[],  window_height: number, window_width: number) {

  const svg  = d3.select(svgRef.current)



  //const y_min = d3.min(dataPoints, d => d['pos_full']);
  //const y_max = d3.max(dataPoints, d => d['pos_full']);

  
  var margin = {top: 100, right: 100, bottom: 30, left: 150},
  width = window_width*.75 - margin.left - margin.right,
  height = window_height*.75 - margin.top - margin.bottom;

  svg.attr("height", height + margin.top + margin.bottom)
  svg.attr("width", width + margin.left + margin.right)

  let chartCanvas = svg.append("g")
  .attr("transform",
      "translate(" + margin.left + "," + margin.top + ")");

  var y_max = 0;

  
  const x_min = seasons[0];
  const x_max = seasons[1];


  if(leagues == 1){
    y_max = 22
  } else if (leagues == 2){
    y_max = 48
  } else if (leagues == 3){
    y_max = 74
  } else{
    y_max = 100
  }

    
  var rect_height = height/(y_max - 1)*0.9
  var rect_width = width/(x_max - x_min)*0.9

  // Add Y axis
  var x = d3.scaleLinear()
    .domain([x_min, x_max])
  .range([0, width]);

  // Add Y axis
  var y = d3.scaleLinear()
    .domain([y_max,1])
  .range([height, 0]);

  svg.selectAll(".x.axis")
  .remove()

  chartCanvas.append("g")
  .attr("transform", "translate(0," + -50 + ")")
        .attr('class', 'x axis')
        .call(d3.axisTop(x).tickFormat(d3.format('.0f')));



  svg.selectAll(".data_points")
   .data(dataPoints)
  .transition()
  .duration(500)
  .attr("x", function (d) { 
    if(d['division'] == '3n'){
      return x(d['season_end_year'])
    } else if(d['division'] == '3s'){
      return x(d['season_end_year'] + 0.5)
    }else {
      return x(d['season_end_year'])
    }} )  .attr("y", function (d) { return y(d['pos_full']); } )
  .attr("width", function (d) { 
                  if(d['season_end_year'] <= x_max && d['season_end_year'] >= x_min){
                    if(d['division'] == '3n' || d['division'] == '3s'){
                      return rect_width/2
                    } else {
                      return rect_width
                    }
                  } else{
                    return 0
                  }
                }
                    )
  .attr("height",function (d) { 
                  if(d['season_end_year'] <= x_max && d['season_end_year'] >= x_min){
                    return rect_height
                  } else{
                    return 0
                  }
                }
    )


  const leauge_names = ["Premier League", "Championship", "League One", "League Two"];
  const league_name_y_start = [1, 25, 51,77];

  const league_name_y_end = [22, 48, 74, 100];


  var class_name = ""

  var div_axes = [div_1_axis, div_2_axis, div_3_axis, div_4_axis]



  //Fix league axes and labels
  for (let i = 0; i < leauge_names.length; i++) {

    //Fix Division Line Seperator
    class_name = ("." + leauge_names[i] + " line").replace(/ /g, '.');

    svg.selectAll(class_name)
    .transition()
    .attr("x1", -margin.left*0.225)
    .attr("x2", -margin.left*0.225)
    .attr("y1", y(league_name_y_start[i]))
    .attr("y2", y(league_name_y_end[i]))

    //Fix Division Labels
    class_name = ("." + leauge_names[i] + " text").replace(/ /g, '.');

    svg.selectAll(class_name)
    .remove()

    chartCanvas.append("text")
    .attr('x', 0)
    .attr('y', 0)      
    .text(leauge_names[i])
    .attr('class', leauge_names[i] + " text")
    .style("font-size", "12px") // Adjust the font size as needed
    .style("text-anchor", "middle") // Center the text horizontally
    .attr("transform", "translate(" + -margin.left*0.275 + "," +  y(league_name_y_start[i] + (league_name_y_end[i] - league_name_y_start[i])/2) + ") rotate(-90)")
    .style('font-weight', 600)

    //Fix Axes
    div_axes[i].range([y(league_name_y_start[i]), y(league_name_y_end[i])]);

    svg.selectAll(".div" + i)
    .remove()

    chartCanvas.append("g")    
    .attr("transform", "translate(" + -10 + ", 0)")
            .attr('class', 'div' + i)
            .call(d3.axisLeft(div_axes[i]).tickValues([5, 10, 15, 20]));
  
    d3.selectAll(".div" + i + " path")
    .style("display", "none"); // Hide the axis line
  
    d3.selectAll(".div" + i + " path")
    .style("font-size", "8px"); // Adjust the font size as needed


}

}

function highlight(svgRef:any, team:any) {

  const svg  = d3.select(svgRef.current)

  console.log("In Highlight:")
  console.log(team)

  console.log("Trying to clear highlights")

  svg.selectAll(".data_points")
  .style("opacity", 0.3)
  .style("stroke", "none");


  if(team.length > 0){
      console.log("Trying to highlight")

      for (let i = 0; i < team.length; i++) {
  
      svg.selectAll("rect[team='" + team[i].team_consolidated + "']")
      .style("opacity", 1)
      .style("stroke", "black") // Set the border color to black
      .style("stroke-width", "1px"); // Set the border width to 2 pixels (adjust as needed)
      }
    
  }
  else{
    console.log("Trying to clear highlights")

    svg.selectAll(".data_points")
    .style("opacity", 0.3)
    .style("stroke", "none");
  }

}

export interface D3ExampleProps {
  circleColor?: string;
  circleSize?: number;
  leagues: number;
  window_width: number;
  window_height: number;
  team: any;
  seasons: number[];
  dataPoints: any[];
}

//This component should only handle displaying the data given to it. Filtering
//data, choosing axis types, and other buisiness logic should be handled in a 
//parent component. 
const D3Example: React.FC<D3ExampleProps> = ({
  circleColor = "red",
  circleSize = 50,
  leagues,
  seasons,
  team,
  window_width,
  window_height,
  dataPoints
}) => {

  const svgRef:any = useRef()


  useEffect(() => {
    draw(svgRef, circleColor, circleSize, dataPoints, window_height, window_width)
  }, [svgRef, dataPoints])
  
  useEffect(() => {
    redraw(svgRef, leagues, dataPoints, seasons,  window_height, window_width)
  }, [leagues, seasons])

  useEffect(() => {

    
    console.log("Team Selected Is: ")
    console.log( team)

    global_team_select = team


    highlight(svgRef, team)

  }, [team])

  return (
    <div >
      <svg ref={svgRef}></svg>
    </div>
  )
};

export default D3Example;
